import { ethers } from "ethers";
import config from "../config/index.js";
import bondAbi from "../abis/BondContract.json";
import erc20Abi from "../abis/ERC20.json";
import lendingAbi from "../abis/Lending.json";
import turboAbi from "../abis/Turbo.json";
import autoCompoundAbi from "../abis/AutoCompound.json";
import reinvestmentAbi from "../abis/ConsolidatedYieldReinvestment.json";
import nftAbi from "../abis/DepositNFT.json";
import treasuryAbi from "../abis/Treasury.json";
import safeVaultAbi from "../abis/SafeVault.json";
import tvtAbi from "../abis/TVT.json";
import marketingEngineAbi from "../abis/MarketingEngine.json";
import priceBandAbi from "../abis/PriceBandExecutor.json";
import treasuryExecutorAbi from "../abis/TreasuryExecutor.json";
import dePegGuardAbi from "../abis/DePegGuard.json";
import selfPayingNettingAbi from "../abis/SelfPayingNetting.json";
import governanceAbi from "../abis/Governance.json";

/**
 * Builds an ethers Contract instance for a known protocol address.
 * @param {"bond"|"safeVault"|"treasury"|"depositNft"|"lending"|"turbo"|"autoCompound"|"reinvestment"|"usdc"|"tvt"|"priceBandExecutor"|"treasuryExecutor"|"marketingEngine"|"selfPayingNetting"|"dePegGuard"|"governance"} kind
 * @param {ethers.ContractRunner} runner Provider or Signer to bind the contract to.
 * @returns {ethers.Contract}
 */
export function getContract(kind, runner) {
    const address = config.contracts[kind];
    if (!address) {
        throw new Error(`Address for ${kind} is not configured. Set VITE_${kind.toUpperCase()}_ADDRESS.`);
    }
    const abi = abiFor(kind);
    return new ethers.Contract(address, abi, runner);
}

function abiFor(kind) {
    switch (kind) {
        case "bond":
            return bondAbi;
        case "lending":
            return lendingAbi;
        case "turbo":
            return turboAbi;
        case "autoCompound":
            return autoCompoundAbi;
        case "reinvestment":
            return reinvestmentAbi;
        case "depositNft":
            return nftAbi;
        case "usdc":
            return erc20Abi;
        case "treasury":
            return treasuryAbi;
        case "safeVault":
            return safeVaultAbi;
        case "tvt":
            return tvtAbi;
        case "marketingEngine":
            return marketingEngineAbi;
        case "priceBandExecutor":
            return priceBandAbi;
        case "treasuryExecutor":
            return treasuryExecutorAbi;
        case "dePegGuard":
            return dePegGuardAbi;
        case "selfPayingNetting":
            return selfPayingNettingAbi;
        case "governance":
            return governanceAbi;
        default:
            return erc20Abi;
    }
}
